import React from 'react';
import { HeaderSimple } from '../components/splash/HeaderSimple';
import { HeroBullets } from '../components/splash/HeroBullets';
import { FeaturesTitle } from '../components/splash/FeaturesTitle';
import { SplashFeatureSection } from '../components/splash/SplashFeatureSection';
import { GetInTouchSimple } from '../components/splash/GetInTouchSimple';
import { FaqSimple } from '../components/splash/FaqSimple';
import { FooterSimple } from '../components/splash/FooterSimple';

const Splash: React.FC = () => {
  return (
    <div>
      {/* Header */}
      <HeaderSimple />

      {/* Hero Section */}
      <HeroBullets />

      {/* Feature Sections */}
      <FeaturesTitle />
      <SplashFeatureSection
        imageSrc="/images/chatbot-demo.jpg"
        imageAlt="AI Chatbot Interface"
        title="ポイント２：海外のお客様の質問に自動で答えますのチャットボット"
        description={<>
          英語を話せるスタッフがいても、外国人のお客様からの質問に一つ一つ対応するのは時間も労力も非常にかかります。
          <br />
          SmartMenuを使えば、あなたのお店専用のAIチャットボットが、海外のお客様からの質問に、24時間いつでも自動で答えます。
          <br />
          おすすめメニューやアレルギー情報など、あなたの店独自の情報も簡単に設定可能。
          <br />
          特別な機器は不要で、お客様のスマホからチャットボットを気軽にご利用いただけます。
        </>}
      />
      <SplashFeatureSection
        imageSrc="/images/order-example.gif"
        imageAlt="Menu Translation Interface"
        title="ポイント３： 海外のお客様とスムーズにコミュニケーションができるシステム"
        description={<>
          海外のお客様は、英語メニューから注文したいものを選び、注文画面をスタッフに見せて注文します。注文画面は日本語でも理解できるデザインのため、スタッフの方も海外のお客様が何を注文したいのか一目で理解することができます。
          <br />
          私たちの目標は、お客様とスタッフが言葉の壁を感じることなく、スムーズにコミュニケーションができるシステムを作ることです。英語と日本語を同時に表示し、誰もが使いやすいサービスを目指しています。
        </>}
      />

      {/* Contact Form */}
      <GetInTouchSimple />
      
      {/* FAQ Section */}
      <FaqSimple />
      
      {/* Footer */}
      <FooterSimple />
    </div>
  );
};

export default Splash; 